// extracted by mini-css-extract-plugin
export var dataCell = "_gm-2";
export var dataRow = "_gm-0";
export var headerRow = "_gm-1";